<template>
  <div v-if="content" class="flex-renderer">
    <template v-if="content.type === 'carousel'">
      <p
        v-if="Array.isArray(content.contents) && content.contents.length > 1"
        class="flex-carousel-hint"
      >
        <i class="ri-arrow-left-right-line" aria-hidden="true"></i>
        左右滑動或拖曳可查看更多
      </p>
      <div
        ref="scrollRef"
        class="flex-carousel"
        @mousedown="startDrag"
      >
        <div class="flex-carousel-track">
          <div v-for="(bubble, i) in content.contents" :key="i" class="flex-carousel-item">
            <FlexBubble :bubble="bubble" />
          </div>
        </div>
      </div>
    </template>
    <FlexBubble v-else-if="content.type === 'bubble'" :bubble="content" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import FlexBubble from './FlexBubble.vue';

defineProps({
  content: { type: Object, default: null }
});

const scrollRef = ref(null);

let isDragging = false;
let dragStartX = 0;
let dragScrollLeft = 0;

function startDrag(e) {
  e.preventDefault();
  const el = scrollRef.value;
  if (!el) return;
  isDragging = true;
  dragStartX = e.pageX - el.offsetLeft;
  dragScrollLeft = el.scrollLeft;
  el.style.cursor = 'grabbing';

  const onMove = (ev) => {
    if (!isDragging) return;
    ev.preventDefault();
    const x = ev.pageX - el.offsetLeft;
    el.scrollLeft = dragScrollLeft - (x - dragStartX);
  };
  const onUp = () => {
    isDragging = false;
    el.style.cursor = 'grab';
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', onUp);
  };
  document.addEventListener('mousemove', onMove);
  document.addEventListener('mouseup', onUp);
}
</script>

<style scoped>
.flex-renderer {
  max-width: 100%;
}
.flex-carousel-hint {
  margin: 0 0 6px;
  padding: 0 2px;
  font-size: 11px;
  line-height: 1.35;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 5px;
}
.flex-carousel-hint i {
  flex-shrink: 0;
  font-size: 14px;
  color: #9ca3af;
}
.flex-carousel {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
}
.flex-carousel::-webkit-scrollbar {
  height: 4px;
}
.flex-carousel::-webkit-scrollbar-track {
  background: transparent;
}
.flex-carousel::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
  transition: background .3s;
}
.flex-carousel:hover::-webkit-scrollbar-thumb,
.flex-carousel:active::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,.2);
}
.flex-carousel-track {
  display: inline-flex;
  gap: 8px;
  padding: 4px 0;
}
.flex-carousel-item {
  flex: 0 0 auto;
  max-width: 220px;
}
</style>
